import { Fragment } from 'react';

import { Feedback } from '@playbooks/molecules/feedbacks';
import { Skeleton } from '@playbooks/molecules/skeletons';
import { cn } from '@playbooks/ui/lib/utils';
import { buildArray } from '@playbooks/utils';

import type { CollectionListProps } from './types';

const PhotoList = ({
	feedbackLayout = 'display',
	skeletonLayout = 'photo',
	icon = 'database',
	title = '',
	text = `We don't have any ${title?.toLowerCase()} that match your criteria.`,
	data = [],
	count = 5,
	loading = false,
	children,
	className = '',
}: CollectionListProps) => {
	// Theme
	const rootClassName = cn('grid w-full gap-3 grid-cols-12 xl:grid-cols-10', className);

	// Render
	return (
		<Fragment>
			{loading ? (
				<div aria-busy='true' className={rootClassName}>
					{buildArray(count).map((v, i) => (
						<div key={i} className='col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-2'>
							<Skeleton layout={skeletonLayout} />
						</div>
					))}
				</div>
			) : data.length ? (
				<div className={rootClassName}>{children}</div>
			) : (
				<Feedback layout={feedbackLayout} icon={icon} title={title} text={text} className={className} />
			)}
		</Fragment>
	);
};
export { PhotoList };
